export const RATE_BUMP_DENOMINATOR = 10000000n;
//# sourceMappingURL=constants.js.map